<template>
  <div ref="myChart" class="chart-box"></div>
</template>

<script>
import * as echarts from "echarts";

const NEON = ["#00e5ff", "#58e2f1", "#1890ff", "#ffa940", "#2ecc71", "#ff6b6b", "#9b59b6", "#1abc9c"];

export default {
  name: "MyChart",
  props: {
    list: Array,
  },
  data() {
    return {
      m_index: -1,
      m_flag: false,
      chart: null,
    };
  },
  mounted() {
    this.$nextTick(() => this.initChart());
    this._onResize = () => {
      if (this.chart) this.chart.resize();
    };
    window.addEventListener("resize", this._onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this._onResize);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.myChart || !this.list || !this.list.length) return;
      if (this.chart) this.chart.dispose();
      this.chart = echarts.init(this.$refs.myChart);
      const myChart = this.chart;
      const data = this.list.map((item, i) => ({
        ...item,
        itemStyle: item.itemStyle || { color: NEON[i % NEON.length] },
      }));
      let a = 0;
      data.forEach((d) => {
        a += d.value || 0;
      });

      myChart.setOption({
        color: NEON,
        series: [
          {
            name: "统计",
            type: "pie",
            startAngle: 90,
            radius: ["54%", "78%"],
            center: ["50%", "50%"],
            data,
            label: {
              normal: { show: false, position: "center" },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: 13,
                  color: "#ffffff",
                  fontWeight: "bold",
                },
              },
            },
            itemStyle: {
              borderColor: "#040b1a",
              borderWidth: 3,
              shadowBlur: 14,
              shadowColor: "rgba(0, 229, 255, 0.45)",
            },
          },
        ],
        graphic: {
          id: "centerTotal",
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: "总数\n" + a,
            textAlign: "center",
            fill: "#00e5ff",
            fontSize: 15,
            fontWeight: 700,
            lineHeight: 22,
          },
        },
      });
      this.$nextTick(() => myChart.resize());

      const showTotal = () => {
        myChart.setOption({
          graphic: {
            id: "centerTotal",
            type: "text",
            left: "center",
            top: "center",
            silent: true,
            style: {
              text: "总数\n" + a,
              textAlign: "center",
              fill: "#00e5ff",
              fontSize: 15,
              fontWeight: 700,
              lineHeight: 22,
              opacity: 1,
            },
          },
        });
      };

      const hideTotal = () => {
        myChart.setOption({
          graphic: {
            id: "centerTotal",
            type: "text",
            left: "center",
            top: "center",
            silent: true,
            style: {
              text: "",
              opacity: 0,
            },
          },
        });
      };

      myChart.off("mouseover");
      myChart.off("mouseout");
      myChart.off("globalout");
      myChart.on("mouseover", (params) => {
        if (params.seriesType === "pie") hideTotal();
      });
      myChart.on("mouseout", (params) => {
        if (params.seriesType === "pie") showTotal();
      });
      myChart.on("globalout", () => {
        showTotal();
      });
    },
  },
};
</script>

<style scoped>
.chart-box {
  width: 100%;
  height: 100%;
  min-height: 140px;
}
</style>
